<template>
  <div class="lumi-banner mb-5 px-4 py-3">
    <div class="row">
      <div class="col-12 col-lg-8 d-flex align-items-center">
        <div class="pr-3">
          <div class="white-circle">
            <img
              class="lumi-img"
              src="@/assets/image/lumi-character.png"
              alt="Lumi"
            />
          </div>
        </div>
        <div>
          <div class="title">Chat with Lumi</div>
          <div>Get answers to your common questions and support issues</div>
        </div>
      </div>
      <div
        class="
          col-12 col-lg-4
          pt-3 pt-lg-0
          d-flex
          align-items-center
          justify-content-end
        "
        @click="handleButtonClick"
      >
        <div class="btn flat-btn primary-blue-btn">Chat on Slack</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";

export default {
  name: "lumi-banner",
  methods: {
    handleButtonClick() {
      this.$hhMixpanel.trackEvent("Contact Support - Chat with Lumi clicked");
      window.open(CONSTANTS.LUMI_SLACK_LINK, "_blank");
    },
  },
};
</script>

<style scoped>
.lumi-banner {
  border-radius: 5px;
  background: rgba(95, 96, 255, 0.11);
  min-height: 98px;
}

.white-circle {
  width: 64px;
  height: 64px;
  background-color: white;
  border-radius: 32px;
}
.lumi-img {
  width: 70px;
  height: 70px;
  margin-left: -2px;
  margin-top: 1px;
}

.title {
  font-family: artifaktElementBold;
  font-size: 20px;
}

.btn {
  font-family: artifaktElementBold;
  text-transform: none;
  line-height: 34px;
}
</style>
